export const CLIENT_ID = '942598579898-uaocosrb4ms1emefdbfohhkqetisuuqj.apps.googleusercontent.com';
